export default __webpack_public_path__ + "static/media/event-team-member-1.9acafe45.jpg";